/*@ngInject*/
const UIStickyElementDirective = function () {

    let linkFunction = function ($scope, $elm, $attrs) {
        let element = $($elm),
            targetSelector = element.data().target || window,
            target = element.closest(targetSelector);

        function handleScroll(e) {
            element.css('transform', 'translateY(' + target.scrollTop() + 'px)');
        };

        target.on('scroll', handleScroll);

        $scope.$on('$destroy', function () {
            element.removeClass('affix');
            target.off('scroll', handleScroll);
        });

        handleScroll();
        element.addClass('affix');
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiStickyElement', UIStickyElementDirective);
